<template>
  <div class="east-block-program-details">
    <div class="east-block-program-details__header">
      <div class="east-block-program-details__header__text">
        <div class="east-block-program-details__header__title">
          <p>{{ programDetails.name }}</p>
        </div>
        <div class="east-block-program-details__header__subtitle">
          <p>{{ $tc('label.days_number', programDetails.duration, { duration: programDetails.duration }) }}</p>
        </div>
      </div>
      <!-- <div class="east-block-program-details__header__action">
        <a><i class="fa fa-star"></i></a>
        <a><i class="fa fa-ellipsis-v"></i></a>
      </div> -->
    </div>
    <div class="east-block-program-details__more-information">
      <div
        v-show="showMoreInformation"
        class="east-block-program-details__more-information__content">
        <hr>
        <p>{{ programDetails.description }}</p>
      </div>
      <div class="east-block-program-details__more-information__toggle">
        <button
          class="button button--more-less is-warning is-small"
          :class="{ 'is-open': showMoreInformation }"
          @click="toggleShowMoreInformation">
          <span class="show-on-close">{{ $t('label.more') }}</span>
          <span class="show-on-open">{{ $t('label.close') }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cmpt-east-block-program-details',
  props: {
    programDetails: {
      required: true,
      default: null,
    },
  },
  data() {
    return {
      showMoreInformation: false,
    };
  },
  methods: {
    toggleShowMoreInformation() {
      this.showMoreInformation = !this.showMoreInformation;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";

  .east-block-program-details {
    display: flex;
    flex-shrink: 0;
    align-self: stretch;
    flex-direction: column;

    .east-block-program-details__header {
      display: flex;
      flex-shrink: 0;
      align-self: stretch;
      padding: 0.5em 0.75em 0.75em;
      justify-content: space-between;
      background-color: $nutrition-facts-orange-light-bg;

      .east-block-program-details__header__text {
        flex-grow: 1;
        display: flex;
        align-self: stretch;
        flex-direction: column;

        .east-block-program-details__header__title {
          font-weight: 600;
          font-size: 1rem;
          line-height: 1.15;
          margin-bottom: 0.25em;
        }
        .east-block-program-details__header__subtitle {
          line-height: 1.15;
          font-size: 0.9rem;
        }
      }
      .east-block-program-details__header__action {
        display: flex;
        align-items: flex-start;
        > * {
          margin-left: 0.5em;
          &:first-child {
            margin-left: 0;
          }
        }
      }
    }
    .east-block-program-details__more-information {
      display: flex;
      flex-direction: column;
      align-items: center;

      .east-block-program-details__more-information__content {
        display: inline-block;
        width: 100%;
        padding: 0.5em 0.75em;
        background-color: $nutrition-facts-orange-light-bg;
        hr {
          margin: 0 0 0.5em 0;
          background-color: $nutrition-facts-orange-light-border;
        }
      }

      .east-block-program-details__more-information__toggle {
        display: flex;
        align-self: stretch;
        align-items: center;
        justify-content: center;
        border-top: 1px solid $nutrition-facts-orange-light-border;
        button {
          margin-right: 0.5em;
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/professional/programs/shared/details/cmpt-east-block-product-detail.vue